import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export default function HiredPanel({ job, refresh }) {
  const hired = job.market?.hired;
  const [text, setText] = useState(hired?.source_text || "");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    try {
      const { data } = await api.post(`/jobs/${job.id}/runs`, { action: "market_hired", params: { text } });
      setBusy(true);
      const poll = async () => {
        const r = (await api.get(`/runs/${data.id}`)).data;
        if (["queued", "running"].includes(r.status)) return setTimeout(poll, 2000);
        setBusy(false);
        r.status === "done" ? toast.success("Hired-profile analysis done") : toast.error(r.error);
        refresh();
      };
      poll();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="card-surface" data-testid="hired-panel">
      <div className="label-xs mb-2">What got people hired</div>
      <textarea data-testid="hired-profiles-input" value={text} onChange={(e) => setText(e.target.value)}
        placeholder="Paste 10–15 LinkedIn profiles of people recently hired into this title (copied manually)"
        className="w-full min-h-[110px] bg-slate-900 border border-border rounded-md p-2 text-xs outline-none focus:border-blue-500" />
      <Button data-testid="hired-analyze-button" size="sm" variant="secondary" className="mt-2" onClick={run} disabled={busy || text.length < 200}>
        {busy && <Loader2 size={13} className="animate-spin mr-1" />} Analyse profiles
      </Button>
      {hired?.common_titles && (
        <div className="mt-4 space-y-3 text-sm" data-testid="hired-results">
          <div><div className="text-xs text-slate-500 mb-1">Common titles</div>{hired.common_titles.map((t) => <span key={t.name} className="inline-block mr-1.5 mb-1 text-xs px-2 py-0.5 rounded bg-emerald-500/10 text-emerald-300">{t.name} · {t.count}</span>)}</div>
          <div><div className="text-xs text-slate-500 mb-1">Common skills</div>{hired.common_skills.map((t) => <span key={t.name} className="inline-block mr-1.5 mb-1 text-xs px-2 py-0.5 rounded bg-blue-500/10 text-blue-300">{t.name} · {t.count}</span>)}</div>
          <div><div className="text-xs text-slate-500 mb-1">Career paths</div><ul className="list-disc pl-4 text-slate-300">{hired.career_paths.map((p, i) => <li key={i}>{p}</li>)}</ul></div>
          <div><div className="text-xs text-slate-500 mb-1">Insights</div><ul className="list-disc pl-4 text-slate-300">{hired.insights.map((p, i) => <li key={i}>{p}</li>)}</ul></div>
        </div>
      )}
    </div>
  );
}
